import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export default class ComplianceCostService {
  private httpClient = makeHttpClient();

  getDetailCountryData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };

    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}country/?${params.toString()}`;
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }

  checkDateFields(date_from: any, date_to: any) {
    if (date_from && date_to) {
      return true;
    } else {
      return false;
    }
  }

  getDetailSchemeData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}scheme/?${params.toString()}`;
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }

  getFinalStreamData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any,
    headerText: any,
    query: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    let url = "";
    if (query) {
      url = `${
        env.ComplianceCostUrl
      }stream/${headerText}/?${params.toString()}${query}`;
    } else {
      url = `${
        env.ComplianceCostUrl
      }stream/${headerText}/?${params.toString()}`;
    }
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }

  getProductFeesData(
    customer: any,
    date_from: any,
    date_to: any,
    countryList: [],
    query: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    let url = "";

    if (query) {
      url = `${env.ComplianceCostUrl}productfee/?${params.toString()}${query}`;
    } else {
      url = `${env.ComplianceCostUrl}productfee/?${params.toString()}`;
    }
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }

  getDetailStreamData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}stream/?${params.toString()}`;
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }

  exportDetailStreamData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any,
    page: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    params.append("stream_name", page);
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${
      env.ComplianceCostUrl
    }export/stream/breakdown/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", "Stream detailed.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return data;
        })
    );
  }

  exportStreamData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}export/stream/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", "Stream.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return data;
        })
    );
  }

  exportSchemeData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}export/scheme/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", "Scheme Compliance Costs.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return data;
        })
    );
  }
  exportCountryData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}export/country/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", "Country Compliance Costs.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return data;
        })
    );
  }
  exportProductFeesData(
    customer: any,
    country: any,
    date_from: any,
    date_to: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    params.append("country", country);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    const url = `${
      env.ComplianceCostUrl
    }export/productfee/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", "Product Fees Compliance Costs.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return data;
        })
    );
  }

  getComplianceDashboardData(
    customer: any,
    schemeList: [],
    countryList: [],
    date_from: any,
    date_to: any,
    filter: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    if (countryList.length > 0) {
      countryList.map(value => {
        params.append("country", "" + value["id"]);
      });
    }
    if (schemeList.length > 0) {
      schemeList.map(value => {
        params.append("scheme", "" + value["id"]);
      });
    }
    params.append("order_by", filter.order);
    params.append("date_from", date_from);
    params.append("date_to", date_to);
    params.append("customer_id", customer);
    params.append("order_field", filter.value);
    const url = `${env.ComplianceCostUrl}product/?${params.toString()}`;
    if (this.checkDateFields(date_from, date_to)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ComplianceCostService>(url, headers)
      );
    } else {
      return {} as JSON;
    }
  }
  // getPresetsList(customer: any) {
  //   const headers = {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //       tenant: customer
  //     }
  //   };
  //   const url = `${env.whatIFAnlysisUrl}playground/preset/scenario/?customer_id=`+customer;
  //   return _unwrapAxiosResponse(
  //     this.httpClient.get<ComplianceCostService>(url, headers)
  //   );
  // }
}
